import { useRef } from 'react';
import { mdMin, smMin } from '../styles/breakpoints';

export const useScrollToElement = (
  topPadding = 0,
  scrollIntoViewBlock: ScrollLogicalPosition | undefined = 'center'
) => {
  const elRef = useRef<HTMLElement | null>(null);

  const handleScrollToElement = () => {
    if (!elRef.current || __IS_SERVER__) {
      return;
    }

    if (window.innerWidth < smMin) {
      const { offsetTop } = elRef.current;
      window.scrollTo({ top: offsetTop - window.innerHeight / 2 + topPadding, behavior: 'smooth' });
      return;
    }

    if (window.innerWidth < mdMin) {
      const { offsetTop } = elRef.current;
      const { height } = elRef.current.getBoundingClientRect();
      window.scrollTo({
        top: offsetTop - 184 - window.innerHeight / 2 + height / 2 + topPadding,
        behavior: 'smooth',
      });
      return;
    }

    elRef.current.scrollIntoView({
      behavior: 'smooth',
      block: scrollIntoViewBlock,
      inline: 'center',
    });
  };

  return {
    elRef,
    onScrollToElement: handleScrollToElement,
  };
};
